/**
 * 直播相关接口
 */

import { post, ApiResponse } from './api';
import { API_PATHS } from './apiPaths';

/**
 * 获取直播详情
 */
export async function getLiveDetail(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.liveDetail, body, { params });
}

/**
 * 获取直播流（轮询）
 */
export async function getLiveStreaming(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.liveStreaming, body, { params });
}

/**
 * 获取直播多机位
 */
export async function getLiveMultiCamera(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.liveMultiCamera, body, { params });
}

/**
 * 直播轮询接口（获取直播状态）
 */
export async function livePoll(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.LivePoll, body, { params });
}

/**
 * 获取直播多机位轮询接口
 */
export async function getLiveMultiCameraPoll(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.GetLiveMultiCamera, body, { params });
}
